import React from "react";
import ReactDOM from "react-dom";
import "./css/index.scss";
import App from "./App";

//Context
import { ProfileUserProvider } from "./lib/profileContext";

ReactDOM.render(
  <ProfileUserProvider>
    <App />
  </ProfileUserProvider>,
  document.getElementById("root")
);
